import { Component, inject, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import type { OnyxRouteBorder } from '@onyx/angular';
import {
  ActionHelper,
  AddressHelper,
  OnyxAddressComponent,
  OnyxFlagsComponent,
  OnyxIconButtonComponent,
  OnyxTooltipDirective,
} from '@onyx/angular';

@Component({
  selector: 'app-route-point-border',
  imports: [
    OnyxIconButtonComponent,
    OnyxTooltipDirective,
    OnyxAddressComponent,
    OnyxFlagsComponent,
    TranslatePipe,
  ],
  templateUrl: './route-point-border.component.html',
  styleUrl: './route-point-border.component.scss',
})
export class RoutePointBorderComponent {
  private readonly actionHelper = inject(ActionHelper);

  public readonly border = input.required<OnyxRouteBorder>();

  protected copyCoordinates(): void {
    this.actionHelper.copy(
      AddressHelper.composeCoordinatesLabel({
        coordinates:
          this.border().address?.coordinates ?? this.border().coordinates,
      }),
    );
  }
}
